import $ from 'jquery';
import LP from './0-lp';
import UI from './0-ui';
import {is_function, isMSIE, parse_float} from '../../Helpers/js/simple.functions';
import {RankingGroup} from './questionnaire';
import {initWaiAriaDropdown} from './ui/ui.wai-aria.dropdown';

// -------------- //
// Poll JS
// -------------- //
LP.Poll = {
  // ----------------
  // Responding Functions
  // ----------------
  initResponse: function () {
    const isThemeV5 = $('body.poll').hasClass('thV5');
    // replace action attribute with current url in adressbar
    // reason: customers might want to use lamapoll via proxy, so the POST has to go
    //         to their address (then they proxy to us) - otherwise wrong cookies are sent with the POST
    $('#pollForm').attr('action', window.location.origin + window.location.pathname);
    LP.Poll.initFormButtons();
    LP.Poll.initAltButtons();
    LP.Poll.initBookmarkButton();
    LP.Poll.initResponsiveIframes();
    LP.Poll.initLightBox();
    LP.Poll.initIframeResizeMode();
    initWaiAriaDropdown(); // Re-initialize WAI-ARIA dropdown after content update
    UI.triggerEvent('onInit');
    UI.triggerEvent('onShow');
    LP.Poll.initCustomTooltips();

    if (isThemeV5 && window.matchMedia('(max-width: 767px)').matches) {
      LP.Poll.initStickyQuestionErrors();
    }
  },
  initCustomTooltips: function () {
    $('.tooltipIcon').each((_, tooltip) => {
      const $tooltip = $(tooltip);
      const $tooltipText = $tooltip.siblings('.tooltip-text').first();
      if (!$tooltip.data('init')) {
        if (!$tooltipText.hasClass('ui basic fixed popup')) {
          $tooltipText.addClass('ui basic fixed popup'); //Fix for legacy tooltips, which have no "ui fixed popup" class
        }
        $tooltip.popup({
          on: 'click',
          popup: $tooltipText,
        });
        $tooltip.on('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
        });
        $tooltip.data('init', true);
      }
    });
  },
  initStickyQuestionErrors: function () {
    const $errorMessages = $('.error-messages');

    $errorMessages.each(function (index, element) {
      const $pageItem = $(element).closest('.item[role="main"]');
      $(element).sticky({
        context: $pageItem,
        offset: 8,
        setSize: false,
      });
    });
  },
  initResponsiveIframes: function () {
    $('iframe').wrap('<div class="responsive-iframe"></div>');
  },

  initIframeResizeMode: function () {
    var json = {
      message: 'iframeresizer loaded',
      survey: $('#poll').data('survey-id'),
    };
    // this timeout prevents these resize-problems: initially sizing to 1px or 150px height
    // but would be better if we could track if iframeresizer loading and just chain this call at the end of if.
    setTimeout(function () {
      window.top.postMessage(JSON.stringify(json), '*');
    }, 100);

    // Once per page load, not per AJAX page change: the embed loader calls iFrameResizer.resize() on it.
    // Moved here from the React Survey component's mount effect.
    if (!LP.Poll.iframeReloadSent) {
      LP.Poll.iframeReloadSent = true;
      setTimeout(function () {
        window.top.postMessage(JSON.stringify({message: 'reload iframeresizer'}), '*');
      }, 200);
    }
  },

  initFormButtons: function () {
    const isThemeDefault4 = $('body.poll').hasClass('default4');
    const isThemeV5 = $('body.poll').hasClass('thV5');

    $('button.button')
      .not('.custom')
      .bind('tap click', function () {
        const isNextButton = $(this).attr('name') == 'next';
        const isBackButton = $(this).attr('name') == 'back';

        $('#chromeSubmitButton').attr('ref', $(this).attr('id')).attr('name', $(this).attr('name')).attr('value', $(this).attr('value'));

        if (isThemeDefault4) {
          LP.Poll.showSubmitLoader(this);
          UI.triggerEvent('onSubmit');
          // do file uploads before submit
          if (!LP.Poll.uploadFiles()) {
            LP.Poll.submit();
          }
        } else if (isThemeV5) {
          if (isNextButton && LP.Poll.needToScrollDown()) {
            LP.Poll.scrollDown();
          } else if (isBackButton && LP.Poll.needToScrollUp()) {
            LP.Poll.scrollUp();
          } else {
            LP.Poll.showButtonLoader(this);
            UI.triggerEvent('onSubmit');
            LP.Poll.submit();
          }
        }
      });
    if (isThemeV5 && window.matchMedia('(max-width: 767px)').matches) {
      LP.Poll.initScrollButtons();
    }
  },

  initScrollButtons: function () {
    const $nextButton = $('button.button[name="next"]').not('.custom');
    const $backButton = $('button.button[name="back"]').not('.custom');

    // check if we need to scroll down on page load and set arrow accordingly
    // timeout is needed to wait for the page to start scrolling up on next-page change
    if (!LP.Poll.needToScrollDown()) {
      //the 'right-arrow' class is used to show the right arrow without animation on page load
      $nextButton.addClass('right-arrow');
    }

    let timeout;
    $(window).on('scroll', function () {
      // timeout is needed to wait for the page to scroll up on page change and only change classes once per scroll
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        if (!LP.Poll.needToScrollDown()) {
          //the 'go-next' class is used to show the right arrow with animation on scroll to the bottom
          $nextButton.addClass('go-next');
        } else {
          $nextButton.removeClass('go-next').removeClass('right-arrow');
        }

        if (LP.Poll.needToScrollUp()) {
          $backButton.addClass('go-up');
        } else {
          $backButton.removeClass('go-up');
        }
      }, 30);
    });
  },
  initLightBox: function () {
    if (window.lightbox) {
      var texts = {
        de: 'Bild %1 von %2',
        en: 'Image %1 of %2',
        es: 'Imagen %1 de %2',
        fr: 'Image %1 de %2',
        nl: 'Afbeelding %1 van %2',
        pt: 'Imagem %1 de %2',
        sv: 'Bilden %1 av %2',
        bg: 'Изображение %1 от %2',
      };
      window.lightbox.option({
        albumLabel: texts[LP.getLanguage()] || texts['en'],
      });
    }
  },

  showSubmitLoader: function (button) {
    $('#formbuttons button.button').css('visibility', 'hidden');

    if (!isMSIE() || isMSIE(10)) {
      $(button).parent().append($('#spinner').html());
    } else {
      $(button).parent().append($('#ie-spinner').html());
    }
  },
  showButtonLoader: function (button) {
    $('button.button').not('.custom').attr('disabled', '1').addClass('disabled');
    $(button).addClass('loading');
  },

  showSubmitButtons: function () {
    $('#formbuttons .spinner').remove();
    $('#formbuttons button.button').css('visibility', 'visible');
  },

  uploadFiles: function () {
    var $uploadFields = $('.upload-field');
    var numUploads = $uploadFields.length;

    if (numUploads > 0) {
      var result = true;
      var uploadDone = function () {
        if (result) {
          LP.Poll.submit();
        } else {
          LP.Poll.showSubmitButtons();
        }
      };

      var curUploadIndex = 0;
      var uploadNext = function () {
        if (curUploadIndex < numUploads) {
          var $field = $uploadFields.eq(curUploadIndex);
          var $e = $('input[type="file"]', $field);

          if ($e.attr('filestate') != '1') {
            // not uploaded already
            $('.upload-loader', $field).show();

            LP.Poll.uploadFile(
              $e.attr('question') + '_' + $e.attr('item'),
              function () {
                curUploadIndex++;
                $('.upload-loader', $field).hide();
                uploadNext();
              },
              function () {
                curUploadIndex++;
                result = false;
                $('.upload-loader', $field).hide();
                uploadNext();
              }
            );
          } else {
            curUploadIndex++;
            uploadNext();
          }
        } else {
          uploadDone();
        }
      };

      uploadNext();

      return true;
    } else {
      return false;
    }
  },

  submit: function () {
    var $form = $('#pollForm');
    var $poll = $('#poll');
    var $pageNumber = $form.find('#pageNumber');
    var $nextButton = $form.find('[name="next"]');
    var $backButton = $form.find('[name="back"]');
    var submitId = $nextButton.length > 0 ? $nextButton.attr('id') : $backButton.length > 0 ? $backButton.attr('id') : '';
    if (submitId == 'chromeSubmitButton') {
      submitId = $nextButton.length > 0 ? $nextButton.attr('ref') : $backButton.length > 0 ? $backButton.attr('ref') : '';
    }

    var url = $form.attr('action');
    var data = $form.serialize();
    var direction = $nextButton.length > 0 ? 'forward' : 'backward';
    if (submitId == 'lp-finish-button') {
      direction = 'finish';
    }
    var curPageNr = $pageNumber.length > 0 ? parseInt($pageNumber.val()) : false;
    var numPages = $pageNumber.length > 0 ? parseInt($pageNumber.attr('max')) : false;

    var returnJson = {
      message: 'lp-submit',
      url: url,
      direction: direction,
    };

    var $respondentId = $poll.find('#respondentId');
    if ($respondentId.length > 0) {
      $.extend(returnJson, {respondentId: parseInt($respondentId.val())});
    }

    window.Browser.send(
      url,
      data,
      function (json) {
        window.Sentry.addBreadcrumb({
          type: 'Navigation',
          category: 'navigation',
          message: 'Entered poll page ' + json.index,
        });

        var isAccepted = json.accepted;
        var isIFrame = window.top !== window;

        var responseNr = json.nr !== undefined ? parseInt(json.nr) : false;
        var nextPageNr = json.index !== undefined ? parseInt(json.index) : false;

        if (isIFrame) {
          //&& pollMode=='real'
          if (isAccepted) {
            $.extend(returnJson, {
              responseNr: responseNr,
              currentPage: curPageNr,
              nextPage: nextPageNr,
              numPages: numPages,
            });
          } else {
            $.extend(returnJson, {
              direction: 'none',
            });
          }

          if (json.redirect_to !== undefined) {
            $.extend(returnJson, {targetURL: json.redirect_to});
          } else if (json.targetURL !== undefined) {
            $.extend(returnJson, {targetURL: json.targetURL});
          }

          window.top.postMessage(JSON.stringify(returnJson), '*');
        }

        if (json.redirect_to !== undefined) {
          window.top.location.href = json.redirect_to;
          return;
        } else {
          $poll.html(json.html);
          if (json.previewFinished) {
            return true;
          }
          var pageChangeNotification = document.getElementById('pageChangeNotification');
          var pageNumber = document.getElementById('pageNumber').value;
          var pageTotalNumber = document.getElementById('pageNumber').max;

          var focusElement = pageChangeNotification;

          //find errors
          var errElements = $('.error-style:visible').get();

          //if errors, search first error
          if (errElements.length > 1 && errElements[0].classList.contains('poll-msg-box')) {
            var pageErrMsg = errElements[0].firstElementChild.innerText; //get message from  poll-msg-box
            var firstQuestionWithErr = errElements[1].closest('div[role = "main"]'); // first element is poll-msg-box, therefore here index 1 needed
            var questionId = firstQuestionWithErr.id.slice(9);
            var firstDutyError = firstQuestionWithErr.querySelector('[data-id="dutyerror_' + questionId + '"]');
            var firstInputError = Array.from(firstQuestionWithErr.getElementsByTagName('input')).find((elem) => elem.closest('.error-style'));
            var firstQuestionError = firstQuestionWithErr.querySelector('[data-id="questionerror_' + questionId + '"]');
            var firstDutyErrorText = firstDutyError ? firstDutyError.innerText : '';
            var firstQuestionErrorText = firstQuestionError ? firstQuestionError.innerText : '';

            //Find element for (screenreader) focus
            if (firstDutyErrorText != '') {
              focusElement = firstDutyError;
            } else if (firstQuestionErrorText != '') {
              focusElement = firstQuestionError;
            } else if (firstInputError) {
              focusElement = firstInputError;
            }

            pageChangeNotification.innerHTML = pageErrMsg;
          } else {
            pageChangeNotification.innerText = window.translate('Current_pollpage', {
              ns: 'Survey',
              pageNumber,
              pageTotalNumber,
            });

            const genericTitlePart = document.getElementsByClassName('poll-title')[0].innerText;
            const specificTitlePart =
              document.getElementsByClassName('page-title')[0]?.innerText ||
              window.translate('Page_number', {
                ns: 'Survey',
                pageNumber,
              });

            document.title = genericTitlePart + ': ' + specificTitlePart;
          }

          //ensure that element is well centered
          focusElement.scrollIntoView({behavior: 'instant', block: 'center', inline: 'nearest'});

          //make element focusable for screenreader
          setTimeout(() => {
            focusElement.tabIndex = '0';
            focusElement.focus({focusVisible: true});
            focusElement.tabIndex = '-1';
          }, 750); //timeout random; question of user experience

          LP.Poll.initResponse();
          return true;
        }
      },
      function (json) {
        var errors = json.errors || [];
        var error = '';
        if (errors.length > 0) {
          error = errors.map(function (text) {
            let errMsg;

            switch (text) {
              case 'serverError':
                errMsg = window.translate('errors.serverError', {ns: 'common'});
                break;
              case 'serverTimeout':
                errMsg = window.translate('errors.serverTimeout', {ns: 'common'});
                break;
              default:
                errMsg = text;
                break;
            }
            return errMsg ? '<p>' + errMsg + '</p>' : '';
          });
        }

        LP.Poll.showSubmitButtons();
        UI.showMsgBox(error || window.translate('errors.unexpectedError', {ns: 'common'}));
        return true;
      }
    );

    return false;
  },
  getPageItems: function () {
    const $form = $('#pollForm');
    //get all items that do not have css style display:"none"
    const allVisibleItems = $form.find('.scroll-target').filter(function (index, element) {
      return $(element).is(':visible');
    });
    return allVisibleItems;
  },
  getNextScrollIndex: function () {
    const tolerance = 50;
    const $pageItems = LP.Poll.getPageItems();

    const scrollHeight = $(document).height();
    const scrollTop = $(window).scrollTop();
    const windowBottom = window.innerHeight + scrollTop;

    if (windowBottom + tolerance > scrollHeight) {
      return false;
    }

    let nextScrollIndex = false;

    $pageItems.each(function (index, element) {
      const itemTop = $(element).offset().top;
      if (itemTop > scrollTop + tolerance) {
        nextScrollIndex = index;
        return false;
      }
    });

    return nextScrollIndex;
  },
  getPrevInvisibleIndex: function () {
    const $pageItems = LP.Poll.getPageItems();
    const windowTop = $(window).scrollTop();
    let previousInvisibleIndex = -1;

    $pageItems.each(function (index, element) {
      var itemTop = Math.floor($(element).offset().top) + 1; //+1 to avoid rounding errors
      if (itemTop < windowTop) {
        previousInvisibleIndex = index;
      }
    });

    return previousInvisibleIndex;
  },
  needToScrollDown: function () {
    // only scroll down on mobile
    if (window.matchMedia('(min-width: 768px)').matches) {
      return false;
    }

    return LP.Poll.getNextScrollIndex() !== false;
  },
  scrollDown: function () {
    const $pageItems = LP.Poll.getPageItems();
    const nextScrollIndex = LP.Poll.getNextScrollIndex();
    const $nextInvisibleItem = $pageItems.eq(nextScrollIndex);

    $('html, body').animate(
      {
        scrollTop: $nextInvisibleItem.offset().top,
      },
      400
    );
  },
  needToScrollUp: function () {
    // only scroll up on mobile
    if (window.matchMedia('(min-width: 768px)').matches) {
      return false;
    }
    const previousInvisibleIndex = LP.Poll.getPrevInvisibleIndex();

    if (previousInvisibleIndex >= 0) {
      return true;
    }
    return false;
  },
  scrollUp: function () {
    const $pageItems = LP.Poll.getPageItems();
    const previousInvisibleIndex = LP.Poll.getPrevInvisibleIndex();

    var $previousInvisibleItem = $pageItems.eq(previousInvisibleIndex);
    $('html, body').animate(
      {
        scrollTop: $previousInvisibleItem.offset().top,
      },
      500
    );
  },
  uploadFile: function (elementId, cb_ok, cb_fail) {
    var element = $('#upload_' + elementId);
    var wrapper = element.closest('.input-wrapper');
    var form = element.closest('form');
    var formURL = form.attr('action');
    var input = $('#answer_' + elementId);
    var pollMode = $('#lp-poll-mode').val();
    input.val('');

    if (element.val().length > 0) {
      $('.upload-label', wrapper).hide();
      $('.upload-file', wrapper).hide();

      var uploadData = {
        task: 'acceptUpload',
        key: $('input[name="key"]', form).val(),
        poll: $('input[name="poll"]', form).val(),
        page: $('input[name="page"]', form).val(),
        question: element.attr('question'),
        input: element.attr('item'),
        sess_id: $('input[name="sess_id"]').val(),
        csrf_token: $('input[name="csrf_token"]').val(),
        mode: pollMode,
      };
      var uploadId = 'upload_' + elementId;

      var onSuccess = function (json) {
        $('.upload-label', wrapper).hide();
        $('.upload-file', wrapper).show();
        $('.upload-file-name', wrapper).html(json.filename);
        $('.upload-file-size', wrapper).html(json.filesize);
        $('.upload-info', wrapper).show();
        $('input[type="file"]', wrapper).attr('fileext', json.fileext);
        $('input[type="file"]', wrapper).attr('filestate', json.filestate);

        if (json.imgType) {
          $('.upload-image', wrapper).show();
          if (json.imgSrc) {
            if (json.imgSrc.substr(0, 4) == 'http') {
              json.imgSrc = json.imgSrc.replace(/&amp;/g, '&');
            }
            $('.upload-image-file', wrapper).attr('src', json.imgSrc);
          }
        } else {
          $('.upload-image', wrapper).hide();
        }
        input.val(json.file);

        if (is_function(cb_ok)) {
          cb_ok(json);
        }
      };
      var onError = function (s) {
        if (is_function(cb_fail)) {
          cb_fail(s);
        }

        $('.upload-label', wrapper).show();
        $('.upload-file', wrapper).hide();

        var errorCode = s.status || 500;
        var lang = LP.getLanguage();
        var errorMsg;

        switch (errorCode) {
          case 413:
            var size = $('#max-file-upload-size').html();
            errorMsg = lang == 'de' ? 'Die Datei ist zu groß (max. ' + size + ')' : 'The Uploaded File is too large (max. ' + size + ')';
            break;
          case 400:
          case 422:
            errorMsg = lang === 'de' ? 'Ungültige Eingabe oder falsches Dateiformat.' : 'Invalid input or incorrect file format.';
            break;
          default:
            errorMsg = lang === 'de' ? 'Der Dateiupload ist fehlgeschlagen (Code: ' + errorCode + ').' : 'Failed uploading file (Code: ' + errorCode + ').';
            break;
        }

        UI.showMsgBox(errorMsg);
      };

      window.Browser.upload(formURL, uploadData, uploadId).then(onSuccess).catch(onError);
    } else {
      if (is_function(cb_ok)) {
        cb_ok();
      }
    }
    return true;
  },

  removeUpload: function (elementId, inputId) {
    var element = $('#' + elementId);
    var wrapper = element.closest('.input-wrapper');
    var form = element.closest('form');
    var formURL = form.attr('action');

    var input = $('#' + inputId);
    input.val('');

    var fileExt = $('input[type="file"]', wrapper).attr('fileext');

    $('.upload-label', wrapper).hide();
    $('.upload-file', wrapper).hide();
    $('.upload-loader', wrapper).show();

    window.Browser.send(
      formURL,
      '&task=removeUpload' +
        '&key=' +
        $('input[name="key"]', form).val() +
        '&poll=' +
        $('input[name="poll"]', form).val() +
        '&page=' +
        $('input[name="page"]', form).val() +
        '&question=' +
        element.attr('question') +
        '&input=' +
        element.attr('item') +
        '&sess_id=' +
        $('input[name="sess_id"]', form).val() +
        '&fileext=' +
        fileExt,
      function () {
        $('.upload-loader', wrapper).hide();
        $('.upload-label', wrapper).show();
        $('.upload-file', wrapper).hide();
        $('.upload-file-name', wrapper).html('');
        $('.upload-file-size', wrapper).html('');

        $('input[type="file"]', wrapper).attr('fileext', '');
        $('input[type="file"]', wrapper).removeAttr('filestate');
        return true;
      },
      function () {
        $('.upload-loader', wrapper).hide();
        $('.upload-label', wrapper).hide();
        $('.upload-file', wrapper).show();
      }
    );
  },
  uploadFile_thV5: function (elementId, cb_ok, cb_fail) {
    var element = $('#upload_' + elementId);
    var wrapper = element.closest('.input-wrapper');
    var form = element.closest('form');
    var formURL = form.attr('action');
    var input = $('#answer_' + elementId);
    var pollMode = $('#lp-poll-mode').val();
    input.val('');

    if (element.val().length > 0) {
      $('.uploaded-file', wrapper).hide();

      var uploadData = {
        task: 'acceptUpload',
        key: $('input[name="key"]', form).val(),
        poll: $('input[name="poll"]', form).val(),
        page: $('input[name="page"]', form).val(),
        question: element.attr('question'),
        input: element.attr('item'),
        sess_id: $('input[name="sess_id"]').val(),
        csrf_token: $('input[name="csrf_token"]').val(),
        mode: pollMode,
      };
      var uploadId = 'upload_' + elementId;

      var onSuccess = function (json, status) {
        $('.upload-file', wrapper).hide();
        $('.uploaded-file', wrapper).show();
        $('.upload-file-name', wrapper).html(json.filename).attr('title', json.filename);
        $('.upload-file-size', wrapper).html(json.filesize);
        $('.upload-info', wrapper).show();
        $('input[type="file"]', wrapper).attr('fileext', json.fileext);
        $('input[type="file"]', wrapper).attr('filestate', json.filestate);
        $('.default-upload-text', wrapper).hide();
        $('.filename-upload-text', wrapper).show();

        if (json.imgType) {
          $('.uploaded-file i', wrapper).removeClass('file alternate outline').addClass('file image outline');
          if (json.imgSrc) {
            if (json.imgSrc.substr(0, 4) == 'http') {
              json.imgSrc = json.imgSrc.replace(/&amp;/g, '&');
            }
            $('.upload-image-file', wrapper).attr('src', json.imgSrc);
          }
          $('.upload-image', wrapper).show();
        } else {
          $('.uploaded-file i', wrapper).removeClass('file image outline').addClass('file alternate outline');
          $('.upload-image-file').attr('src', '');
          $('.upload-image', wrapper).hide();
        }
        input.val(json.file);

        if (is_function(cb_ok)) {
          cb_ok(json);
        }
      };
      var onError = function (s, xml, status, e) {
        if (is_function(cb_fail)) {
          cb_fail(s);
        }

        $('.uploaded-file', wrapper).hide();
        var errorCode = s.status || 500;
        var lang = LP.getLanguage();
        var errorMsg;

        switch (errorCode) {
          case 413:
            var size = $('#max-file-upload-size').html();
            errorMsg = lang == 'de' ? 'Die Datei ist zu groß (max. ' + size + ')' : 'The Uploaded File is too large (max. ' + size + ')';
            break;
          case 400:
          case 422:
            errorMsg = lang === 'de' ? 'Ungültige Eingabe oder falsches Dateiformat.' : 'Invalid input or incorrect file format.';
            break;
          default:
            errorMsg = lang === 'de' ? 'Der Dateiupload ist fehlgeschlagen (Code: ' + errorCode + ').' : 'Failed uploading file (Code: ' + errorCode + ').';
            break;
        }
        UI.showMsgBox(errorMsg);
      };

      window.Browser.upload(formURL, uploadData, uploadId).then(onSuccess).catch(onError);
    } else {
      if (is_function(cb_ok)) {
        cb_ok();
      }
    }
    return true;
  },

  removeUpload_thV5: function (elementId) {
    var element = $('#upload_' + elementId);
    var wrapper = element.closest('.input-wrapper');
    var form = element.closest('form');
    var formURL = form.attr('action');
    var input = $('#answer_' + elementId);
    input.val('');

    var fileExt = $('input[type="file"]', wrapper).attr('fileext');

    $('.upload-loader', wrapper).show();

    window.Browser.send(
      formURL,
      '&task=removeUpload' +
        '&key=' +
        $('input[name="key"]', form).val() +
        '&poll=' +
        $('input[name="poll"]', form).val() +
        '&page=' +
        $('input[name="page"]', form).val() +
        '&question=' +
        element.attr('question') +
        '&input=' +
        element.attr('item') +
        '&sess_id=' +
        $('input[name="sess_id"]', form).val() +
        '&fileext=' +
        fileExt,
      function () {
        $('.upload-loader', wrapper).hide();
        $('.upload-file', wrapper).show();
        $('.uploaded-file', wrapper).hide();
        $('.upload-file-name', wrapper).html('');
        $('.upload-file-size', wrapper).html('');
        $('.upload-image-file').attr('src', '');
        $('.default-upload-text', wrapper).show();
        $('.filename-upload-text', wrapper).hide();

        $('input[type="file"]', wrapper).attr('fileext', '');
        $('input[type="file"]', wrapper).removeAttr('filestate');
        $('.max-size-error', wrapper).hide();
        return true;
      },
      function () {
        $('.upload-loader', wrapper).hide();
        $('.uploaded-file', wrapper).show();
        $('.upload-file', wrapper).hide();
      }
    );
  },
  trapFocus: function (element) {
    var focusableEls = element.querySelectorAll(
      'span[tabindex="0"], a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    element.addEventListener('keydown', function (e) {
      var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  },

  togglePageOverlay: function (selector) {
    const $item = $('.page-overlay' + selector);
    $item.toggleClass('visible');

    if ($item.hasClass('visible')) {
      LP.Poll.trapFocus($item[0]);
      $(document).keyup(function (e) {
        if (e.keyCode === 27) {
          LP.Poll.togglePageOverlay(selector);
        }
      });
      $('.page-overlay' + selector + ' .shadow').click(function () {
        LP.Poll.togglePageOverlay(selector);
      });
    } else {
      $(document).unbind('keyup');
      $('.page-overlay' + selector + ' .shadow').unbind('click');
      $(selector.slice(0, -8)).focus();
    }
  },

  initBookmarkButton: function () {
    $('a#lp-interrupt-poll').bind('touchstart click', function () {
      UI.showMsgBox($('#lp-interrupt-text').html(), UI.MsgBox.mOK | UI.MsgBox.mFRONTEND);
      $('.lp-bookmark')
        .button()
        .click(function (e) {
          e.preventDefault(); // this will prevent the anchor tag from going the user off to the link
          var bookmarkUrl = this.href;
          var bookmarkTitle = this.title;

          if (window.sidebar) {
            // For Mozilla Firefox Bookmark
            window.sidebar.addPanel(bookmarkTitle, bookmarkUrl, '');
          } else if (window.external || document.all) {
            // For IE Favorite
            window.external.AddFavorite(bookmarkUrl, bookmarkTitle);
          } else if (window.opera) {
            // For Opera Browsers
            var jQueryBookmark = $('a.jQueryBookmark');
            jQueryBookmark.attr('href', bookmarkUrl);
            jQueryBookmark.attr('title', bookmarkTitle);
            jQueryBookmark.attr('rel', 'sidebar');
          } else {
            // for other browsers which does not support
            alert('Your browser does not support this bookmark action');
            return false;
          }

          return false;
        });
    });
  },

  initAltButtons: function () {
    var altButton = $('.lp-alt-next');
    if (altButton.length != 0) {
      altButton
        .attr('tabindex', '0')
        .css('cursor', 'pointer')
        .click(function () {
          var $this = $(this);
          var data = $this.attr('href');
          if (data) {
            data = data.split('#');
            var form = $('#pollForm');
            for (var i = 0; i < data.length; i++) {
              var d = data[i].split('=');
              $('<input>').attr('type', 'hidden').attr('name', d[0]).attr('value', d[1]).appendTo(form);
            }
          }

          LP.Poll.triggerOptionButton($(this));
          UI.skipDeselect = true;
          setTimeout(LP.Poll.triggerNextClick, 100);
          return false;
        })
        .keydown(function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).click();
          }
        });
    }
  },

  triggerNextClick: function () {
    var nextButton = $('button.button[name="next"]');

    if (isMSIE(8)) {
      nextButton.trigger('click');
    } else {
      nextButton.click();
    }
    return true;
  },

  triggerPrevClick: function () {
    var backButton = $('button.button[name="back"]');

    if (isMSIE(8)) {
      backButton.trigger('click');
    } else {
      backButton.click();
    }
    return true;
  },

  triggerOptionButton: function (button) {
    var parentOption = button.closest('.choice-option');
    if (parentOption) {
      var choiceOption = $('input', parentOption);
      if (choiceOption) {
        choiceOption.trigger('click');
      }
    }
  },

  supressEnterKey: function (evt) {
    var evtk = evt ? evt : event ? event : null;
    var node = evtk.target ? evtk.target : evtk.srcElement ? evtk.srcElement : null;

    if (evtk.keyCode == 13 && (node.type == 'text' || node.type == 'number')) {
      return false;
    }
    return true;
  },

  showPollElement: function (elementId) {
    var $group;
    var $element = $(elementId);
    var tagname = $element.prop('tagName');
    var onShowEvent = function () {
      UI.triggerEvent('onChange', elementId);
      UI.triggerEvent('onShow', elementId);
    };

    if (tagname === 'OPTGROUP') {
      $element.css('display', 'block').removeAttr('disabled');
      $('option', $element).each(function (i, el) {
        $(el).css('display', 'block').removeAttr('disabled');
      });
      onShowEvent();
    } else if (tagname === 'OPTION') {
      $element.css('display', 'block').removeAttr('disabled');
      $group = $element.closest('optgroup');
      if ($group.length > 0) {
        $group.css('display', 'block').removeAttr('disabled');
      }
      onShowEvent();
    } else if (tagname === 'TH') {
      $element.show();
      onShowEvent();
    } else {
      if ($element.hasClass('choice-option')) {
        $group = $element.closest('.choice-group');
        if ($group.length > 0) {
          $group.slideDown('fast', onShowEvent);
        }
      }
      $element.slideDown('fast', onShowEvent);
    }
  },

  hidePollElement: function (elementId) {
    var $element = $(elementId);
    var tagname = $element.prop('tagName');
    var onHideEvent = function () {
      UI.triggerEvent('onChange', elementId);
      UI.triggerEvent('onHide', elementId);
    };
    if (tagname === 'OPTGROUP') {
      $element.css('display', 'none').attr('disabled', 'disabled');
      onHideEvent();
      $('option', $element)
        .filter(':selected')
        .each(function (i, el) {
          $(el).removeAttr('selected').change();
        });
      $('option', $element).each(function (i, el) {
        $(el).css('display', 'none').attr('disabled', 'disabled');
      });
    } else if (tagname === 'OPTION') {
      $element.css('display', 'none').removeAttr('selected').attr('disabled', 'disabled');
      onHideEvent();
      var $group = $element.closest('optgroup');
      if ($group.length > 0 && $group.find('option:visible').length === 0) {
        $group.css('display', 'none').attr('disabled', 'disabled');
      }
    } else if (tagname === 'TH') {
      $element.hide();
      onHideEvent();
    } else {
      if ($element.attr('option-group')) {
        $element.slideUp('fast', onHideEvent);
        $('input[type="radio"]', $element).prop('checked', false);
        $('input[type="checkbox"]', $element).prop('checked', false);
      } else if ($element.hasClass('choice-option')) {
        $('input', $element).prop('checked', false);
        $element.slideUp('fast', onHideEvent);
        // and if the group doesn't have any more elements, hide it
        $group = $element.closest('.choice-group');
        // the current element doesn't count as hidden yet, so we have to remove it manually from the results
        if ($group.length > 0 && $group.find('.choice-option:visible').not('#' + $element.attr('id')).length === 0) {
          $group.slideUp('fast', onHideEvent);
        }
      } else {
        if (tagname === 'INPUT') {
          $element.prop('checked', false);
          $element.slideUp('fast', onHideEvent);
        } else {
          $('input', $element).prop('checked', false);
          $element.slideUp('fast', onHideEvent);
        }
      }
    }
  },

  togglePollElement: function (elementId, shouldShowOrHide) {
    var $element = $(elementId);
    var isVisible = $element.is(':visible');
    var isHidden = $element.css('display') === 'none';
    if (shouldShowOrHide) {
      // should show
      if (!isVisible || isHidden) {
        LP.Poll.showPollElement(elementId);
      }
    } else {
      // should hide
      if (isVisible || !isHidden) {
        LP.Poll.hidePollElement(elementId);
      }
    }
  },

  captchaUpdateLock: false,
  updateCaptcha: function (event, elementId, inputId, captchaId, captchaTask, captchaURL, captchaKey) {
    event.stopPropagation();
    if (LP.Poll.captchaUpdateLock) {
      return false;
    }

    LP.Poll.captchaUpdateLock = true;
    var params = {
      refresh: true,
      captcha: captchaId,
      key: captchaKey,
    };

    if (captchaTask) {
      params.task = captchaTask;
    }

    params.sess_id = $('input[name="sess_id"]').val();
    params.csrf_token = $('input[name="csrf_token"]').val();

    window.Browser.send(
      captchaURL,
      params,
      function (json) {
        LP.Poll.captchaUpdateLock = false;
        var c = $('#captcha_' + inputId);
        c.attr('src', json.image);
        $('#solved_' + inputId).hide();
        $('#answer_' + elementId + '_' + inputId).val('');
      },
      function () {
        LP.Poll.captchaUpdateLock = false;
        return true;
      }
    );

    return false;
  },

  // --------------------
  // Scoring Sum Methods
  // --------------------

  updateScoringSum: function (questionId) {
    var questionSum = 0;
    if (questionId) {
      questionSum = LP.Poll.computeScore($('input[score]', $('#question_' + questionId)));
      $('.lp-scoring-sum-q-' + questionId).each(function (index, span) {
        $(span).html(questionSum);
      });

      $('.lp-scoring-part-q-' + questionId).each(function (index, span) {
        var groupCls = span.className.split(' ')[1];
        var groupRef = 'lp-score-group-';
        var groupClass = groupCls.substr(0, groupRef.length);
        var groupId = groupCls.substr(groupRef.length);

        if (groupClass == groupRef) {
          var groupSum = LP.Poll.computeScore($('input[score]', $('.chgroup_' + questionId + '_' + groupId)));
          $(span).html(groupSum);
        }
      });
    }

    var pageSum = LP.Poll.computeScore($('input[score]'));
    $('.lp-scoring-sum-p').each(function (index, span) {
      $(span).html(pageSum);
    });

    var totalSum = pageSum;
    var lpTotalSum = $('#lp-total-sum');
    if (lpTotalSum.val()) {
      totalSum = parse_float(totalSum + parse_float(lpTotalSum.val(), 2), 2);
    }
    $('.lp-total-scoring').each(function (index, span) {
      $(span).html(totalSum);
    });

    var relativeSum = '0%';
    var relScore = $('.lp-relative-scoring');
    var maxPoints = relScore.data('max');
    if (maxPoints) {
      relativeSum = parse_float((totalSum / parse_float(maxPoints, 2)) * 100, 2) + '%';
    }
    relScore.each(function (index, span) {
      $(span).html(relativeSum);
    });

    if (questionId) {
      return questionSum;
    } else {
      return totalSum;
    }
  },

  computeScore: function (inputs) {
    var sum = 0;
    inputs.each(function (index, input) {
      input = $(input);
      var type = input.attr('type');

      var score = input.attr('score');

      if (score == 'current') {
        score = parse_float(input.val(), 2);
      } else if (score == 'noAnswer') {
        score = parse_float('0', 2);
      } else {
        score = parse_float(score, 2);
      }
      if (!score) {
        return;
      }
      if ((type == 'radio' || type == 'checkbox') && !input.is(':checked')) {
        return;
      }
      sum = sum + score;
    });
    return sum;
  },
};

//---------- //
//Ranking UI //
//---------- //
LP.Poll.Ranking = {
  init: function (rankingId, questionId) {
    var rankingNode = document.getElementById(rankingId);
    var onChange = (e) => LP.Poll.Ranking.onChange(e, rankingNode, questionId);
    new RankingGroup(rankingNode, onChange);
  },

  onChange: function (e, rankingNode, questionId) {
    var options = rankingNode.getElementsByTagName('li');
    var valueText = rankingNode.getAttribute('data-valuetext');
    var successText = rankingNode.getAttribute('data_successtext');
    var numOptions = $(options).filter(':visible').length;
    var position = 0;
    for (var i = 0; i < options.length; i++) {
      var node = options[i];
      var $node = $(node);

      node.setAttribute('aria-valuemax', numOptions);

      if (!$node.is(':visible')) {
        node.getElementsByTagName('input')[0].value = '';
        node.setAttribute('aria-valuenow', '');
        continue;
      }
      position++;
      node.getElementsByTagName('input')[0].value = position;
      node.setAttribute('aria-valuenow', position);
      node.setAttribute(
        'aria-valuetext',
        e == 'userchange' ? successText + ' ' + valueText.replace('%x', position).replace('%y', numOptions) : valueText.replace('%x', position).replace('%y', numOptions)
      );
    }
    UI.triggerEvent('onChange', '#pageitem_' + questionId);
  },
};
